import{__require as r}from"./fails.js";var n,t;function e(){if(t)return n;t=1;var e=r();return n=!e((function(){var r=function(){}.bind();return"function"!=typeof r||r.hasOwnProperty("prototype")}))}export{e as __require};
//# sourceMappingURL=function-bind-native.js.map
